export const filterOptionsSelect = (arrayOptions, arraySelected, name) => {
  const lastItem = arraySelected[arraySelected.length - 1];
  if (!lastItem) return arrayOptions;
  const lastOption = lastItem[name];
  const resultOptions = arrayOptions.filter(
    (option) => option.cftIdTo === lastOption.cftIdFrom
  );
  return resultOptions;
};
